import React from 'react';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';

const InfoButton = ({ title, placement }) => {
  return (
    <Tooltip title={title} placement={placement}>
      <IconButton color="primary" aria-label="info">
        <InfoIcon />
      </IconButton>
    </Tooltip>
  );
};

export default InfoButton;
